// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"b865628e","453":"d855a71b","466":"e181ce21","576":"97ffc6ad","780":"33e02b28"}[chunkId] + ".chunk.js";
};